import { LegalLayout } from "./LegalLayout";
import { SOCLOSE } from "../../constants/soclose";

const PRODUCT = "3DPrintForge";

export function LegalNoticePage() {
  return (
    <LegalLayout title="Legal Notice" updatedAt="2025-12-16">
      <h2>Publisher</h2>
      <address className="legal-address">
        <strong>{SOCLOSE.name}</strong><br />
        {SOCLOSE.legalForm}<br />
        Registered in Singapore under {SOCLOSE.uenLabel}<br />
        Registration date: {SOCLOSE.registrationDate}<br />
        Issuance agency: ACRA (Accounting and Corporate Regulatory Authority of Singapore)
      </address>

      <h2>Registered office</h2>
      <address className="legal-address">
        {SOCLOSE.address.line1}<br />
        {SOCLOSE.address.line2}<br />
        {SOCLOSE.address.country} {SOCLOSE.address.postal}
      </address>

      <h2>Business activities</h2>
      <ul>
        <li><strong>Primary:</strong> {SOCLOSE.business.primary}</li>
        <li><strong>Secondary:</strong> {SOCLOSE.business.secondary}</li>
      </ul>

      <h2>Contact</h2>
      <ul>
        <li>Email: <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a></li>
        <li>Phone: <a href={`tel:${SOCLOSE.contact.phoneRaw}`}>{SOCLOSE.contact.phone}</a></li>
        <li>Website: <a href={SOCLOSE.contact.website}>{SOCLOSE.contact.website}</a></li>
      </ul>

      <h2>Publication director</h2>
      <p>The publication director of <strong>{PRODUCT}</strong> is the duly appointed legal representative of {SOCLOSE.name}.</p>

      <h2>Hosting</h2>
      <p>
        The Service is hosted on a dedicated server operated by SoClose. For details about the data centre or transit
        providers, contact <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a>.
      </p>

      <h2>Intellectual property</h2>
      <p>
        Unless otherwise stated, all content on <strong>{PRODUCT}</strong> (text, graphics, logos, code) is the exclusive
        property of {SOCLOSE.name} and protected by Singapore and international copyright laws. Any reproduction without
        prior written consent is prohibited.
      </p>

      <h2>Reporting an issue</h2>
      <p>
        To report illegal content, a copyright infringement, or a security vulnerability, contact{" "}
        <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a> with a clear description and proof of
        rights when applicable. We respond within 5 business days.
      </p>

      <h2>Governing law</h2>
      <p>
        This Legal Notice and any matter relating to the Service are governed by the laws of Singapore. Disputes are
        subject to the exclusive jurisdiction of the Singapore courts.
      </p>
    </LegalLayout>
  );
}
